const initialState = {
  items: [],
  cartTotal: 0,
};

export { initialState };
